import { render, staticRenderFns } from "./SavFilters.vue?vue&type=template&id=79f5a89d&"
import script from "./SavFilters.vue?vue&type=script&lang=js&"
export * from "./SavFilters.vue?vue&type=script&lang=js&"
import style0 from "./SavFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports